import React from 'react';

const StyledInput = ({ value, onChange, placeholder }) => {
  const inputStyles = {
    border: '1px solid #ccc',
    borderRadius: '4px',
    paddingLeft: '8px',
    paddingRight: '28px',
    fontSize: '1rem',
    minHeight: '38px', // Matches react-select's default height
    boxShadow: 'none',
    outline: 'none',
    transition: 'border-color 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
    width: '100%',
    boxSizing: "border-box",
  };

  const focusStyles = {
    borderColor: '#2684FF', // Same blue focus border as react-select
    boxShadow: '0 0 0 2px #2684FF',
  };

  const svgStyles = {
    position: "absolute",
    right: "8px",
    top: "50%",
    transform: "translateY(-50%)",
    width: "20px",
    height: "20px",
    // color: #888,
    pointerEvents: "none", /* So the icon doesn’t block clicks on the input */
  };

  const [isFocused, setIsFocused] = React.useState(false);

  return (
    <div style={{position: "relative"}}>
      <input
        type="text"
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        style={{ ...inputStyles, ...(isFocused ? focusStyles : {}) }}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
      />
      <svg style={{ ...svgStyles}}
      viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fillRule="evenodd" clipRule="evenodd" d="M14.0096 12.8274L19.7479 18.5745C20.084 18.9109 20.084 19.4113 19.7479 19.7477C19.4118 20.0841 18.9118 20.0841 18.5757 19.7477L12.8169 13.9842C11.4643 15.0467 9.7592 15.6825 7.90655 15.6825C3.54545 15.6825 0 12.167 0 7.8433C0 3.51964 3.55364 0 7.91475 0C12.2758 0 15.8213 3.51554 15.8213 7.8392C15.8213 9.73439 15.1409 11.4696 14.0096 12.8274ZM7.90655 1.68598C4.47587 1.68598 1.6805 4.44672 1.6805 7.8433C1.6805 11.2358 4.47587 14.0006 7.90655 14.0006C11.3372 14.0006 14.1326 11.2399 14.1326 7.8433C14.1326 4.44672 11.3372 1.68598 7.90655 1.68598Z" fill="black" />
      </svg>
    </div>
  );
};

export default StyledInput;